<!-- <template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn0 btn-secondary">
          <i class="bi bi-plus-square"></i>
          Actualiser
        </button>

      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'raw-materials-items-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
    </div>
    <br> 

    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence</th>
          <th scope="col">Fournisseur</th>
          <th scope="col">Date</th>
          <th scope="col">Montant Total</th>
          <th scope="col">Total Qté</th>
          <th scope="col">Total Qté (U*)</th>
          <th scope="col">M. Payé</th>
          <th scope="col">M. à Régler</th>
          <th scope="col">Créer par</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(raw_material, index) in raw_materials" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ raw_material.reference }}
          </td>
          <td>
            <span v-if="raw_material.supplier">
              {{ raw_material.supplier.society }}
            </span>
          </td>
          <td>{{ raw_material.date }}</td>
          <td class="text-info">
            <span
              v-if="raw_material.totalPriceTTC != null"
              class="bg-primary px-2 rounded"
            >
              {{ raw_material.totalPriceTTC }}
            </span>
          </td>
          <td class="text-warning">
            <span v-if="raw_material.totalQuantity != null">
              {{ raw_material.totalQuantity }}
            </span>
          </td>

          <td class="text-warning">
            <span v-if="raw_material.totalQuantityUnit != null">
              {{ raw_material.totalQuantityUnit }}
            </span>
          </td>
          <td class="text-success">
            <span
              class="bg-light-success px-2 rounded"
            >
              {{ raw_material.amountPaid }}
            </span>
          </td>
          <td class="text-danger">
            <span
              v-if="raw_material.amountUnpaid != null"
              class="bg-warning px-2 rounded"
            >
              {{ raw_material.amountUnpaid }}
            </span>
          </td>
          <td>
            
            <span v-if="raw_material.user">
              {{ raw_material.user.name }}
            </span>
          </td>
          <td class="p-0 m-0">
            <button
              @click="
                $router.push({
                  name: 'raw-materials-details',
                  params: { reference: raw_material.reference },
                })
              "
              class="btn"
            >
              <i class="bi bi-info-square fs-5"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("rawMaterial", {
      raw_materials: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("rawMaterial/getAll");

    // setInterval(() => {
    //   this.$store.dispatch("purchase/getAll");
    // }, 3000);
  },
  methods: {
    async search(value) {
      return await this.$store.commit("rawMaterial/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("rawMaterial/getAll");
    },

    async listRawMaterials(checkbox) {
      if (checkbox == true) {
        console.log(checkbox);
        return await this.$store.commit("rawmMaterial/getTodays");
      } else {
        return await this.$store.dispatch("rawMaterial/getRawMaterials");
      }
    },
    async sort(value) {
      return await this.$store.commit("rawMaterial/sort", value);
    },
  },
};
</script> -->

<template>
  <div>
    <div class="row row-sm">
      <div class="col-xl-3 col-lg-3 col-md-6 col-12 my-3">
        <label for=""> Fournisseur <span class="text-danger">*</span> </label>

        <vue-select 
          :options="suppliers"
          v-model="filter.supplier_reference"
          placeholder="Fournisseur"
          labelColumn="society"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-12 my-3">
        <label for="">Du <span class="text-danger">*</span> </label>
        <input v-model="filter.startDate" type="date" class="form-control" />
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-12 my-3">
        <label for=""> Au <span class="text-danger">*</span> </label>
        <input v-model="filter.endDate" type="date" class="form-control" />
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-12 my-3">
        <label for=""> État de paiement </label>
        <select v-model="filter.paymentStatus" class="form-select">
          <option value="--">--</option>
          <option value="Payé">Payé</option>
          <option value="Impayé">Impayé</option>
        </select>
      </div>
      
    </div>

    <div class="row justify-content-end mb-3">

      <div class="col-xl-auto col-12 my-xl-0 my-3">
        <button @click="toFilter(filter)" class="btn btn0 btn-secondary">
          <i class="bi bi-funnel"></i> Rechercher
        </button>
      </div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'raw-materials-items-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
    </div>

    <vue-data-table
      :headers="headers"
      :data="raw_materials"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
    >
      <!-- Exemple custom pour amountPaid -->
      <template #cell-amountPaid="{ row }">
        <span class="px-2 py-1 rounded"
          :class="row.amountPaid > 0
            ? 'bg-light-success text-success'
            : 'bg-light-danger text-danger'">
          {{ row.amountPaid > 0 ? row.amountPaid : 'Impayé' }}
        </span>
      </template>

      <!-- Exemple custom pour amountUnpaid -->
      <template #cell-amountUnpaid="{ row }">
        <span v-if="row.amountUnpaid != null"
          class="px-2 py-1 rounded bg-light-danger text-danger ">
          {{ row.amountUnpaid }}
        </span>
      </template>

      <!-- Exemple custom pour totalPriceTTC -->
      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded bg-light-primary ">
          {{ row.totalPriceTTC }}
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
      },
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "supplierName", label: "Fournisseur", class: "" },
        { field: "date", label: "Date", class: "" },
        { field: "totalPriceTTC", label: "Montant Total", class: "" },
        { field: "totalQuantity", label: "Total Qté", class: "" },
        { field: "totalQuantityUnit", label: "Qté Net", class: "" },
        { field: "amountPaid", label: "M. Payé", class: "" },
        { field: "amountUnpaid", label: "M. à Régler", class: "" },
        { field: "userName", label: "Créer par", class: "" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-info-square",
          class: "btn btn-primary",
          action: (row) => {
            this.$router.push({
              name: "raw-materials-details",
              params: { reference: row.reference },
            });
          },
        },
      ],
      summableColumns: [
        { field: "totalPriceTTC", class: "" },
        { field: "totalQuantity", class: "" },
        { field: "totalQuantityUnit", class: "" },
        { field: "amountPaid", class: "text-success" },
        { field: "amountUnpaid", class: "text-danger" },
      ],
    };
  },
  computed: {
    ...mapGetters("rawMaterial", {
      raw_materials: "getAll",
    }),
     ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("rawMaterial/getAll");
    this.$store.dispatch("supplier/getAll");
  },
  methods: {
    async refresh() {
      return await this.$store.dispatch("rawMaterial/getAll");
    },

      async toFilter(data) {
      return await this.$store.dispatch("rawMaterial/filter", data);
    },
  },
};
</script>
